import React, { Component } from 'react';
class OrderlahLogoBar extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div style={{position:"absolute", lineHeight:"28px",width:"100vw", left:"0px", textAlign:"center",zIndex:"-5",height:"50px", top: "0px", padding: "0px 0px 5px 0px"}}>    
                <img src={this.props.customLogo || "/image/orderlah_1row.png"} style={{height:"100%", width:"auto"}}/>
            </div>
        );
    }
}

export default OrderlahLogoBar;